import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, slicedToArray as _slicedToArray, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from '../../theming/styled-components.js';
import themes from '../../theming/themes.js';
import React, { memo, useRef, useState, forwardRef, useCallback, useEffect } from 'react';
import withDefaultTheme from '../../hocs/withDefaultTheme.js';
import { parse } from 'date-fns';
import DatePicker from 'react-datepicker';
import { TextInput, Icon } from '../../index.js';

var _excluded = ["value", "onClick", "field", "onChange", "onFocus", "disabled", "theme", "datePickerRef", "hasIcon"],
  _excluded2 = ["onChange", "theme", "initialValue"];
var _templateObject, _templateObject2;
// TODO: Some of these colors are not in our theme palette
var StyledDatePickerContainer = styled('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &&& .react-datepicker {\n    border-radius: 0;\n    border-color: 1px solid #ccc;\n  }\n\n  &&& .react-datepicker-wrapper {\n    width: 100%;\n  }\n\n  &&& .react-datepicker-popper[data-placement^='bottom'] {\n    margin-top: calc(-1.375rem + -10px);\n  }\n\n  &&& .react-datepicker-popper {\n    z-index: 100;\n  }\n\n  &&& .react-datepicker__current-month {\n    display: none;\n  }\n\n  &&& .react-datepicker__month-select,\n  &&& .react-datepicker__year-select {\n    border: 1px solid ", ";\n    color: ", ";\n    font-size: 0.9375rem;\n    height: 1.5rem;\n  }\n\n  &&& .react-datepicker__navigation {\n    top: 7px;\n  }\n\n  &&& .react-datepicker__header {\n    background: ", ";\n    border-bottom: none;\n  }\n\n  &&& .react-datepicker__header__dropdown {\n    margin-bottom: 1.125rem;\n  }\n\n  &&& .react-datepicker__day,\n  &&& .react-datepicker__day-name {\n    font-size: 1rem;\n    height: 1.875rem;\n    width: 2.1875rem;\n  }\n\n  &&& .react-datepicker__day--outside-month {\n    color: #ccc;\n  }\n\n  &&& .react-datepicker__day--selected,\n  &&& .react-datepicker__day--keyboard-selected {\n    background-color: ", ";\n    border: 1px solid #3ea6c5;\n    color: ", ";\n    border-radius: 0;\n  }\n\n  &&& .react-datepicker__navigation-icon {\n    &::before {\n      border-color: ", ";\n    }\n  }\n\n  &&& .react-datepicker__day--in-range {\n    background-color: inherit;\n    color: inherit;\n    &:hover {\n      background-color: #f0f0f0;\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.grayLight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.grayDark;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.palette.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.palette.white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.palette.secondary;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.palette.secondary;
});
var DatePickerIcon = styled('button')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translate3d(0, -50%, 0);\n  &:hover {\n    cursor: pointer;\n  }\n"])));
var _TextInput = /*#__PURE__*/forwardRef(function (_ref7, ref) {
  var value = _ref7.value,
    onClick = _ref7.onClick,
    field = _ref7.field,
    onChange = _ref7.onChange,
    onFocus = _ref7.onFocus,
    disabled = _ref7.disabled,
    theme = _ref7.theme,
    datePickerRef = _ref7.datePickerRef,
    _ref7$hasIcon = _ref7.hasIcon,
    hasIcon = _ref7$hasIcon === void 0 ? true : _ref7$hasIcon,
    rest = _objectWithoutProperties(_ref7, _excluded);
  // Opted in for true on the validators since we wouldn't want to add it
  // everytime to get the benefit of our baked in date validation logic...
  // Can still be overriden with validateOnBlur=false and/or validateOnChange=false
  var validate = rest.validate,
    _rest$validateOnBlur = rest.validateOnBlur,
    validateOnBlur = _rest$validateOnBlur === void 0 ? true : _rest$validateOnBlur,
    _rest$validateOnChang = rest.validateOnChange,
    validateOnChange = _rest$validateOnChang === void 0 ? true : _rest$validateOnChang;
  var handleOnClick = function handleOnClick(e) {
    var _datePickerRef$curren;
    // eslint yelling at me for no-unused-expressions
    datePickerRef === null || datePickerRef === void 0 || (_datePickerRef$curren = datePickerRef.current) === null || _datePickerRef$curren === void 0 || _datePickerRef$curren.setOpen(true); // eslint-disable-line
    e.preventDefault();
  };
  var closeDatePicker = useCallback(function (e) {
    if (e.key === 'Escape') {
      var _datePickerRef$curren2;
      datePickerRef === null || datePickerRef === void 0 || (_datePickerRef$curren2 = datePickerRef.current) === null || _datePickerRef$curren2 === void 0 || _datePickerRef$curren2.setOpen(false); // eslint-disable-line
    }
  }, []);
  useEffect(function () {
    // @ts-ignore
    document.addEventListener('keydown', closeDatePicker, false);
    return function () {
      // @ts-ignore
      document.removeEventListener('keydown', closeDatePicker, false);
    };
  }, []);
  var handleValidation = function handleValidation(input) {
    if ((validateOnBlur || validateOnChange) && input && input.length < 10 && input) {
      return 'Please enter a valid date!';
    }
    if (validate) {
      validate(input);
    }
    return undefined;
  };
  return /*#__PURE__*/React.createElement(TextInput
  // TODO: Allow custom format
  , _extends({
    formatter: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
    maintainCursor: true,
    onClick: onClick,
    forwardedRef: ref,
    onChange: onChange,
    field: field,
    onFocus: onFocus,
    disabled: disabled,
    initialValue: value,
    theme: themes.lincoln,
    validate: handleValidation,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    datePickerValue: value,
    "data-testid": field,
    datePickerIcon: hasIcon && /*#__PURE__*/React.createElement(DatePickerIcon, {
      "aria-label": "Choose a date using the datepicker",
      onClick: handleOnClick
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "calendar",
      size: "medium",
      color: "secondary"
    }))
  }, rest));
});
// TODO: allow multiple formats & time - not just MM/dd/yyyy
// TODO: evaluate why selectsStart doesn't work but selectsEnd does (starts off when you tab at the endDate)
// TODO: investigate translation of built in validation
// TODO: restyle dropdown section of custom calendar header
var DatePickerV2 = function DatePickerV2(_ref8) {
  var onChange = _ref8.onChange,
    _ref8$theme = _ref8.theme,
    theme = _ref8$theme === void 0 ? themes.lincoln : _ref8$theme,
    initialValue = _ref8.initialValue,
    rest = _objectWithoutProperties(_ref8, _excluded2);
  var datePickerRef = useRef(null);
  var initialDate = initialValue ? parse(initialValue, 'MM/dd/yyyy', new Date()) : null;
  var _useState = useState(initialDate),
    _useState2 = _slicedToArray(_useState, 2),
    selectedDate = _useState2[0],
    setSelectedDate = _useState2[1];
  var handleOnChange = function handleOnChange(date) {
    if (onChange) {
      onChange(date);
    }
    setSelectedDate(date);
  };
  return /*#__PURE__*/React.createElement(StyledDatePickerContainer, {
    "data-testid": "date-picker",
    theme: theme
  }, /*#__PURE__*/React.createElement(DatePicker, _extends({
    showMonthDropdown: true,
    showYearDropdown: true,
    dropdownMode: "select",
    selected: selectedDate,
    onChange: handleOnChange,
    customInput: /*#__PURE__*/React.createElement(_TextInput, _extends({
      datePickerRef: datePickerRef
    }, rest)),
    showPopperArrow: false,
    ref: datePickerRef,
    preventOpenOnFocus: true,
    popperModifiers: [{
      name: 'computeStyles',
      options: {
        adaptive: false
      }
    }]
  }, rest)));
};
var index = withDefaultTheme(/*#__PURE__*/memo(DatePickerV2));

export default index;
export { _TextInput };
